import { Check, X } from 'lucide-react'

import { cn } from '@/utils'

interface PlanFeaturesProps {
  features: string[]
  available?: string[]
  className?: string
}

const ALL_FEATURES = [
  'Extraction',
  'AI Chat',
  'Forensic reports',
  'Self-healing reconciliation',
]

export default function PlanFeatures({
  features,
  available = ALL_FEATURES,
  className = 'mt-6 space-y-3.5 xl:grid xl:grid-cols-2 xl:gap-x-8 xl:gap-y-4 xl:space-y-0',
}: PlanFeaturesProps) {
  return (
    <ul className={cn(className)}>
      {available.map((feature) => {
        const included = features.includes(feature)

        return (
          <li key={feature} className="flex items-start gap-3 text-sm">
            <span
              className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${
                included ? 'bg-brand' : 'bg-muted'
              }`}
            >
              {included ? (
                <Check className="h-3 w-3 text-white" strokeWidth={3} />
              ) : (
                <X className="h-3 w-3 text-muted-foreground" strokeWidth={3} />
              )}
            </span>
            <span
              className={`text-pretty leading-snug ${included ? '' : 'text-muted-foreground'}`}
            >
              {feature}
            </span>
          </li>
        )
      })}
    </ul>
  )
}
